import { render, staticRenderFns } from "./GtsInfoWidget.vue?vue&type=template&id=0c9fd130&scoped=true"
import script from "./GtsInfoWidget.vue?vue&type=script&lang=js"
export * from "./GtsInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./GtsInfoWidget.vue?vue&type=style&index=0&id=0c9fd130&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9fd130",
  null
  
)

export default component.exports